import React from 'react';
import { Link } from 'react-router-dom';

function DKSUToast() {
  return (
    <div>
      <h6 className="text-white">У вас є непрочитані повідомлення</h6>
      <p>
        Перейти до перегляду за
        <Link className="text-white ms-2" to="/email/inbox">посиланням</Link>
      </p>
    </div>
  );
}

export default DKSUToast;
